export function validateSignup (values) {
  const errors = {}
  // username validation
  if (!values.username.trim()) {
    errors.username = 'Please enter your first and last name'
  } else if (/^[0-9]*$/.test(values.username)) {
    errors.username = 'The name must not contain numbers'
  } else if (!/^[A-Za-z]+/.test(values.username.trim())) {
    errors.username = 'Enter a valid name'
  }
  // email validation
  if (!values.email) {
    errors.email = 'Email required'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid'
  }
  // password validation
  if (!values.password) {
    errors.password = 'Password is required'
  } else if (values.password.length < 6) {
    errors.password = 'The password must be at least 6 characters long'
  }
  return errors
}

export function validateLogin (values) {
  const errors = {}
  // email validation
  if (!values.email) {
    errors.email = 'Email required'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid'
  }
  // password validation
  if (!values.password) {
    errors.password = 'Password is required'
  } else if (values.password.length < 6) {
    errors.password = 'The password must be at least 6 characters long'
  }
  return errors
}

export function validateReset (values) {
  const errors = {}
  // email validation
  if (!values.email) {
    errors.email = 'Email required'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid'
  }
  return errors
}
